const unsubmitted = 'unsubmitted';
const submitted = 'submitted';
const completed = 'completed';
const error = 'error';

export const updatePasswordStatuses = {
  unsubmitted,
  submitted,
  completed,
  error
};
